/** Normalize a company name for case/whitespace-insensitive comparison. */
export function normalizeCompanyName(name: string | null | undefined): string {
  if (!name) return "";
  return name.trim().replace(/\s+/g, " ").toLowerCase();
}

/** True when two non-blank names normalize equal. Blank never matches. */
export function companyNamesMatch(
  a: string | null | undefined,
  b: string | null | undefined
): boolean {
  const na = normalizeCompanyName(a);
  const nb = normalizeCompanyName(b);
  if (na === "" || nb === "") return false;
  return na === nb;
}
